import makeStyles from '@mui/styles/makeStyles';
import NRRemediationStepsStyles from '../NRRemediationSteps.styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';
import clsx from 'clsx';
import { Controller, useFormContext } from 'react-hook-form';
import FormControl from '@mui/material/FormControl';
import NRSwitch from '../../NRControlledSwitch/NRSwitch';

const useStyles = makeStyles(NRRemediationStepsStyles);

function pluralizeItemType(itemType) {
  const words = itemType.split(' ').map(word => word.toLowerCase());
  const lastWord = words[words.length - 1];
  words[words.length - 1] = `${lastWord}s`;
  return words.join(' ');
}

function NRCryptographyRemediationStepThree({ itemTypeLabel = 'Certificate' }) {
  const classes = useStyles();
  const { control } = useFormContext();
  const pluralizedItemType = pluralizeItemType(itemTypeLabel);
  return (
    <Box>
      <Box sx={{ mt: 5 }}>
        <Typography variant={'body2'} className={classes.textSecondary}>
          You can export these {pluralizedItemType} as part of a Cryptography Bill of Materials (CBOM) in SBOM format from here, or Save and export
          from the SBOM tab at anytime.
        </Typography>
      </Box>
      <Box sx={{ mb: 1 }}>
        <Typography variant={'body2'} className={clsx(classes.optionalExport, classes.textSecondary)}>
          Optional Export
        </Typography>
        <Box className={classes.selectedVex}>
          <Box className={classes.innerSelectedVex}>
            <Typography variant={'body2'} sx={{ mr: 1 }}>
              Open SBOM export options after saving
            </Typography>
          </Box>
          <FormControl>
            <Controller
              control={control}
              id={'remediation-downloadSBOM'}
              name={'downloadSBOM'}
              required={false}
              render={({ field: { onChange, value } }) => <NRSwitch onChange={v => onChange(v?.target?.checked)} value={value} />}
            />
          </FormControl>
        </Box>
      </Box>
    </Box>
  );
}

export default NRCryptographyRemediationStepThree;
